import { render, staticRenderFns } from "./faturadizayntanimlama.vue?vue&type=template&id=2620cea9&"
import script from "./faturadizayntanimlama.vue?vue&type=script&lang=js&"
export * from "./faturadizayntanimlama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports